module.exports = __webpack_public_path__ + "homeStatic/img/time-icon.a2d8f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/time-icon.png
// module id = FY2D
// module chunks = 1